import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
var StarIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/React.createElement(BaseSvg, _extends({}, otherProps, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.539,3.32c0.065,-0.191 0.247,-0.32 0.451,-0.32c0.203,0 0.385,0.129 0.45,0.32l1.281,3.743l3.994,0.048c0.204,0.003 0.383,0.134 0.446,0.325c0.063,0.192 -0.004,0.403 -0.168,0.523l-3.202,2.362l1.188,3.773c0.06,0.193 -0.01,0.402 -0.175,0.521c-0.165,0.118 -0.388,0.12 -0.554,0.003l-3.26,-2.283l-3.26,2.283c-0.167,0.117 -0.39,0.115 -0.555,-0.003c-0.165,-0.119 -0.235,-0.328 -0.174,-0.521l1.187,-3.773l-3.202,-2.362c-0.164,-0.12 -0.231,-0.331 -0.168,-0.523c0.063,-0.191 0.242,-0.322 0.446,-0.325l3.994,-0.048l1.281,-3.743Z"
  }));
});
StarIcon.displayName = 'StarIcon';
export default StarIcon;